import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 20, height = 19, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 20 19' fill='none'>
  <path d='M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.63L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27Z' fill={color}/>
</svg>
